import rison from 'rison';

import { api } from './Api';
import { getRequestParams } from '../utils/api';

const COLUMNS = [
  "id", "name", "uid", "status", "flow_run_id", "created_on_utc", "context_json", "details_json", "parent_id",
  "start_time", "end_time",
]; // mandatory for the UI

export const getNoteflowExecution = (uid: string, detailed: boolean = true) => {
  const requestParams: any = {};

  if (!detailed) {
    requestParams['columns'] = COLUMNS;
  }

  return api.get(`/noteflow_run/${uid}?q=${rison.encode(requestParams)}`).then((res: any) => res.data);
}

export const getNoteflowExecutions = (properties?: any, pageUid?: string) => {
  let requestParams = getRequestParams(properties);
  requestParams = {
    ...requestParams,
    columns: COLUMNS, // exclude `logs`
  }

  return api.get(`/noteflow_run/?q=${rison.encode(requestParams)}`)
    .then((res: any) => res.data);
}

export const getReRuns = (parentId: string, flowRunId?: string) => {
  let params: string = '';
  if (!!flowRunId) {
    params += `?flow_run_id=${flowRunId || ''}`;
  }

  return api.get(`/noteflow_run/${parentId}/get_re_runs${params}`)
    .then((res: any) => res.data);
}

export const getNoteflowExecutionLogs = (flowRunUid: string) => {
  const requestParams = {
    filters: [
      {
        col: 'flow_run_id',
        opr: 'frid_eq',
        value: flowRunUid
      }
    ],
    page: 0,
    page_size: -1,
  }

  return api.get(`/noteflow_run_log/?q=${rison.encode(requestParams)}`).then((res: any) => res.data);
}

export const getNoteflowTaskResults = (uid: string) => {
  /*
   * Get `query` and `block_execution` uid along with their `results_key`
   */
  return api.get(`/noteflow_run/${uid}/get_task_results`).then((res: any) => res.data);
}
